/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttendanceBlockedDto } from '../models/AttendanceBlockedDto';
import type { AttendanceBlockedInput } from '../models/AttendanceBlockedInput';
import type { AttendanceLogUserDto } from '../models/AttendanceLogUserDto';
import type { HolidayRequestApproveInput } from '../models/HolidayRequestApproveInput';
import type { HolidayRequestDto } from '../models/HolidayRequestDto';
import type { HolidayRequestDtoPagedListData } from '../models/HolidayRequestDtoPagedListData';
import type { HolidayRequestInput } from '../models/HolidayRequestInput';
import type { ScheduleDto } from '../models/ScheduleDto';
import type { ScheduleSummaryDto } from '../models/ScheduleSummaryDto';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { UpdateScheduleInput } from '../models/UpdateScheduleInput';
import type { UserRole } from '../models/UserRole';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AttendanceService {

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequestsStatuses(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-requests/statuses',
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequestsTypes(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-requests/types',
    });
  }


  /* @param date 
  * @returns any Success
  * @throws ApiError
  */
  public static getSchedulesExportEmployeeAveragePay(
    date: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/export-employee-average-pay',
      query: {
        'Date': date,
      },
    });
  }

  /**
   * @param myActive 
   * @param branchId 
   * @param departmentId 
   * @param employeeName 
   * @param employeeId 
   * @param excludeEmployeeId 
   * @param statusId 
   * @param isIntersecting 
   * @param dateStart 
   * @param dateEnd 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param canWorkInHoliday 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns HolidayRequestDtoPagedListData Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequests(
    myActive: boolean,
    branchId?: number,
    departmentId?: number,
    employeeName?: string,
    employeeId?: number,
    excludeEmployeeId?: number,
    statusId?: number,
    isIntersecting?: boolean,
    dateStart?: string,
    dateEnd?: string,
    sort?: string,
    order?: SortTypeEnum,
    canWorkInHoliday?: boolean,
    skipPagination?: boolean,
    page?: number,
    maxCount?: number,
  ): CancelablePromise<HolidayRequestDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-requests',
      query: {
        'MyActive': myActive,
        'BranchId': branchId,
        'DepartmentId': departmentId,
        'EmployeeName': employeeName,
        'EmployeeId': employeeId,
        'ExcludeEmployeeId': excludeEmployeeId,
        'StatusId': statusId,
        'IsIntersecting': isIntersecting,
        'DateStart': dateStart,
        'DateEnd': dateEnd,
        'Sort': sort,
        'Order': order,
        'CanWorkInHoliday': canWorkInHoliday,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postSchedulesHolidayRequests(
    requestBody?: HolidayRequestInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/schedules/holiday-requests',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @returns number Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequestsNotApprovedCount(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-requests/not-approved-count',
    });
  }

  /**
   * @param id 
   * @returns HolidayRequestDto Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequests1(
    id: number,
  ): CancelablePromise<HolidayRequestDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-requests/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteSchedulesHolidayRequests(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/schedules/holiday-requests/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedulesHolidayRequestsApprove(
    id: number,
    requestBody?: HolidayRequestApproveInput,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules/holiday-requests/{id}/approve',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedulesHolidayRequestsApprove1(
    requestBody?: Array<number>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules/holiday-requests/approve',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedulesHolidayRequestsReject(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules/holiday-requests/{id}/reject',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedulesHolidayRequestsReject1(
    requestBody?: Array<number>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules/holiday-requests/reject',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedulesHolidayRequestsCancel(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules/holiday-requests/{id}/cancel',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param userId 
   * @param dateStart 
   * @param dateEnd 
   * @param branchId 
   * @param statusId 
   * @param departmentId 
   * @returns any Success
   * @throws ApiError
   */
  public static getSchedulesHolidayRequestCsv(
    userId?: number,
    dateStart?: string,
    dateEnd?: string,
    branchId?: number,
    statusId?: number,
    departmentId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/holiday-request-csv',
      query: {
        'UserId': userId,
        'DateStart': dateStart,
        'DateEnd': dateEnd,
        'BranchId': branchId,
        'StatusId': statusId,
        'DepartmentId': departmentId,
      },
    });
  }

  /**
   * @param dateSchedule 
   * @param dateFrom 
   * @param dateTo 
   * @param departmentId 
   * @param branchId 
   * @param role
 *
 * 0 = DefaultEmployee (Роль по умолчанию, минимум возможностей)
 *
 * 1 = Administrator (Имеет доступ ко всем страницам и всему функционалу)
 *
 * 2 = Accountant (Бухгалтер)
 *
 * 3 = BdcAdvisor
 *
 * 4 = BodyshopManager
 *
 * 5 = PartsDriver
 *
 * 6 = PartsManager
 *
 * 7 = SalesAdministrator
 *
 * 8 = SalesConsultant (Анжела его еще называет Sales Exec)
 *
 * 9 = SalesManager
 *
 * 10 = ServiceAdvisor
 *
 * 11 = ServiceDriver
 *
 * 12 = ServiceManager
 *
 * 13 = SiteCoordinator
 *
 * 14 = Valetor
 *
 * 15 = Technician
 *
 * 16 = CarBuyer
 *
 * 17 = BodyshopOperative
 *
 * 18 = Marketing
 *
 * 19 = Maintenance
   * @param employeeName 
   * @returns ScheduleDto Success
   * @throws ApiError
   */
  public static getSchedules(
    dateSchedule: string,
    dateFrom?: string,
    dateTo?: string,
    departmentId?: number,
    branchId?: number,
    role?: UserRole,
    employeeName?: string,
  ): CancelablePromise<Array<ScheduleDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules',
      query: {
        'DateSchedule': dateSchedule,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'DepartmentId': departmentId,
        'BranchId': branchId,
        'Role': role,
        'EmployeeName': employeeName,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSchedules(
    requestBody?: Array<UpdateScheduleInput>,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/schedules',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param employeeIds 
   * @param dateFrom 
   * @param dateTo 
   * @returns ScheduleSummaryDto Success
   * @throws ApiError
   */
  public static getSchedulesSummary(
    employeeIds: Array<number>,
    dateFrom: string,
    dateTo: string,
  ): CancelablePromise<Array<ScheduleSummaryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/summary',
      query: {
        'EmployeeIds': employeeIds,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param branchId 
   * @param departmentId 
   * @returns any Success
   * @throws ApiError
   */
  public static getSchedulesExportSummary(
    dateFrom: string,
    dateTo: string,
    branchId?: number,
    departmentId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/export-summary',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'BranchId': branchId,
        'DepartmentId': departmentId,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postSchedulesHolidayRequestsCountDays(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/schedules/holiday-requests-count-days',
    });
  }

  /**
   * @returns AttendanceBlockedDto Success
   * @throws ApiError
   */
  public static getSchedulesMonthReadOnly(): CancelablePromise<Array<AttendanceBlockedDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/month-read-only',
    });
  }

  /**
   * @param date 
   * @returns boolean Success
   * @throws ApiError
   */
  public static getSchedulesMonthReadOnlyState(
    date: string,
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/month-read-only/{date}/state',
      path: {
        'date': date,
      },
    });
  }

  /**
   * @param date 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postSchedulesMonthReadOnlyToggle(
    date: string,
    requestBody?: AttendanceBlockedInput,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/schedules/month-read-only/{date}/toggle',
      path: {
        'date': date,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param minEmploymentEndDateInclude 
   * @param branchId 
   * @param departmentId 
   * @param userName 
   * @returns AttendanceLogUserDto Success
   * @throws ApiError
   */
  public static getSchedulesUsers(
    minEmploymentEndDateInclude?: string,
    branchId?: number,
    departmentId?: number,
    userName?: string,
  ): CancelablePromise<Array<AttendanceLogUserDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/users',
      query: {
        'MinEmploymentEndDateInclude': minEmploymentEndDateInclude,
        'BranchId': branchId,
        'DepartmentId': departmentId,
        'UserName': userName,
      },
    });
  }

  /**
   * @param userId 
   * @param dateStart 
   * @param dateStartType 
   * @param dateEnd 
   * @param dateEndType 
   * @param remainingDays 
   * @returns number Success
   * @throws ApiError
   */
  public static getSchedulesCalculateHolidayDuration(
    userId: number,
    dateStart: string,
    dateStartType: number,
    dateEnd: string,
    dateEndType: number,
    remainingDays: number,
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/schedules/calculate-holiday-duration',
      query: {
        'UserId': userId,
        'DateStart': dateStart,
        'DateStartType': dateStartType,
        'DateEnd': dateEnd,
        'DateEndType': dateEndType,
        'RemainingDays': remainingDays,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
